export const Feature = {
  INVITE: {
    _: 'invite',
    INVITE_ICON: 'invite_icon',
    INVITE_GIFTS: 'invite_icon_energy_gift',
    INVITE_POPUP_MULTI: 'invite_popup_multi',
    INVITE_POPUP_MULTI_SELECT: 'invite_popup_multi_select',
    INVITE_POPUP_MULTI_OK: 'invite_popup_multi_ok',
    INVITE_POPUP_MULTI_CANCEL: 'invite_popup_multi_cancel',
    GEMS_ICON: 'invite_gems_icon',
    INVITE_LAUNCH: 'invite_launch',
    INVITE_UNLOCK: 'invite_unlock',
    INVITE_LOW_BALANCE: 'invite_low_balance',
    INVITE_INSTEAD_GEMS_SHOP: 'invite_instead_gems_shop',
    INVITE_NO_ENERGY: 'invite_no_energy',
  },
  GIFTS: {
    _: 'gift',
    SEND_ENERGY: 'gift_energy_single',
    SEND_ENERGY_AND_COLLECT: 'gift_energy_and_collect',
    SEND_ENERGY_ALL: 'gift_energy_all',
  },
  VISIT: {
    _: 'visit',
    FRIEND: 'visit_friend',
    REWARD: 'visit_reward',
    NON_FRIEND: 'visit_non_friend',
    POPUP_FRIEND_BUSY: 'visit_popup_friend_busy',
    POPUP_FRIEND_DEAD: 'visit_popup_friend_dead',
    POPUP_CONFIRM_VISIT: {
      _: 'visit_popup_confirm_visit',
      CLOSE: 'visit_popup_confirm_visit_close',
      OK: 'visit_popup_confirm_visit_ok',
    },
    POPUP_VISIT_FRIEND: {
      _: 'visit_popup_visit_friend',
      TAB_FRIENDS: 'visit_popup_visit_friend_tab_friends',
      TAB_VISITORS: 'visit_popup_visit_friend_tab_visitors',
      CLOSE: 'visit_popup_visit_friend_close',
      SELECT: 'visit_popup_visit_friend_select',
    },
    POPUP_VISIT_REWARD: {
      _: 'visit_popup_visit_reward',
      CLOSE: 'visit_popup_visit_reward_close',
    },
  },
  STATUS: {
    _: 'status',
  },
  NOTIFICATION: {
    _: 'notification',
    ENERGY_FULL: 'notification_energy_full',
  },
  GREETING: {
    _: 'greeting',
  },
  NATIVE: {
    _: 'native',
    PROMO_BUTTON: 'native-promo-button',
    POPUP_INSTALL_IOS: 'native-popup-install-ios',
    POPUP_INSTALL_ANDROID: 'native-popup-install-android',
    POPUP_INSTALL_UNKNOWN: 'native-popup-install-unknown',
    POPUP_INSTALL_CLOSE: 'native-popup-install-close',
    DOWNLOAD_IOS: 'native-download-ios',
    DOWNLOAD_ANDROID: 'native-download-android',
    DOWNLOAD_UNKNOWN: 'native-download-unknown',
    POPUP_INSTALL_REWARD_IOS: 'native-popup-install-reward-ios',
    POPUP_INSTALL_REWARD_ANDROID: 'native-popup-install-reward-android',
    POPUP_INSTALL_REWARD_UNKNOWN: 'native-popup-install-reward-unknown',
    POPUP_INSTALL_REWARD_CLOSE: 'native-popup-install-reward-close',
    LINE_GUEST_LOGIN: 'native-line-guest-login',
    LINE_GUEST_LOGIN_OK: 'native-line-guest-login-ok',
    LINE_GUEST_LOGIN_CLOSE: 'native-line-guest-login-close',
  },

  DUO: {
    _: 'duo',
    INVITE: 'duo_invite',
    RESPONSE: 'duo_response',
    REMINDER: 'duo_reminder',
    FORM_DUO: 'duo_form_duo',

    REWARD_POPUP: {
      _: 'duo_reward_popup',
      CLOSE: 'duo_reward_popup_close',
    },

    POPUP_DUO_INVITATIONS: {
      _: 'duo_popup_duo_invitations',
      TAB_SENT: 'duo_popup_duo_invitations_tab_sent',
      TAB_RECEIVED: 'duo_popup_duo_invitations_tab_received',
      CLOSE: 'duo_popup_duo_invitations_close',
      SELECT: 'duo_popup_duo_invitations_select',
      REMIND: 'duo_popup_duo_invitations_remind',
    },

    RESPONSE_POPUP: {
      _: 'duo_response_popup',
      ERROR: 'duo_response_popup_error',
      CLOSE: 'duo_response_popup_close',
      CONFIRM: 'duo_response_popup_confirm',
    },

    REMINDER_CONFIRMATION_POPUP: {
      _: 'duo_reminder_confirmation_popup',
      CLOSE: 'duo_reminder_confirmation_popup_close',
      CONFIRM: 'duo_reminder_confirmation_popup_confirm',
    },

    REMINDER_SUCCESS_POPUP: {
      _: 'duo_reminder_success_popup',
      CLOSE: 'duo_reminder_success_popup_close',
    },

    RESPOSE_SUCCESS_POPUP: {
      _: 'duo_response_success_popup',
      CLOSE: 'duo_response_success_popup_close',
    },
  },

  DEBUT: {
    _: 'debut',
    INVITER: 'debut_inviter',
    INVITEE: 'debut_invitee',
  },
} as const;
